import { render } from "./AdminEvaluation.vue?vue&type=template&id=6f42db50&scoped=true"
import script from "./AdminEvaluation.vue?vue&type=script&lang=js"
export * from "./AdminEvaluation.vue?vue&type=script&lang=js"

import "./review-evaluate.scss?vue&type=style&index=0&id=6f42db50&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f42db50"]])

export default __exports__